import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { CustomHeightProgressBars } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HEIGHT_PROGRESS_DATA, HEIGHT_PROGRESS_LIST } from "../../../../Data/UiKit/Progress/index";

export const CustomHeightProgressBarsCart = () => {
  return (
    <Card>
      <CommonCardHeader title={CustomHeightProgressBars} span={HEIGHT_PROGRESS_DATA} />
      <Row className="card-body progress-showcase">
        <Col>
          <Progressbar color="primary" value="25" style={{height: "1px",}}/>
          {HEIGHT_PROGRESS_LIST.map(({ color, value, height }, index) => (
            <Progressbar color={color} value={value} style={{height: `${height}`,}} key={index}/>
          ))}
        </Col>
      </Row>
    </Card>
  );
};
